import { request, RespError, handleFormatRes } from '../../utils';
import { USER_COUPON_LIST } from '../../config/url';
export var UserCouponTransState;
(function (UserCouponTransState) {
    UserCouponTransState["UNUSED"] = "1";
    UserCouponTransState["USED"] = "2";
    // USING = '3', // 出于10分钟倒计时的5001券
    UserCouponTransState["OPENED"] = "3";
})(UserCouponTransState || (UserCouponTransState = {}));
/** 优惠券信息 */
export var UserCouponSpType;
(function (UserCouponSpType) {
    UserCouponSpType["NO_CDKEY"] = "5001";
    UserCouponSpType["CDKEY"] = "5002";
    UserCouponSpType["SINGLE_CDKEY"] = "5003";
})(UserCouponSpType || (UserCouponSpType = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = ['cpNum', 'spNum', 'cvNum', 'fusingState', 'ownState', 'recommend'];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['receiveTime', 'expireTime', 'validTime', 'modifyTime', 'validTime'];
/**
 * 拉取用户已领取的券列表
 *
 * 拉取用户已领取的券列表
 *
 * 接口地址：`/app/coupon/prom_user_coupon_list.cgi`
 *
 * @param
 * @returns
 */
export async function userCouponList({ couponIdList }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            coupon_id_list: JSON.stringify(Array.isArray(couponIdList) ? couponIdList : [couponIdList]),
        };
        // 接口请求
        const result = await request.get(USER_COUPON_LIST, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    transformer: (res) => {
                        if (res.spInfo) {
                            return Object.assign(Object.assign({}, res), { spInfo: res.spInfo
                                    ? res.spInfo.map((spCoupon) => {
                                        const { userScid } = spCoupon;
                                        // eslint-disable-next-line no-param-reassign
                                        delete spCoupon.userScid;
                                        return Object.assign(Object.assign({}, spCoupon), { userCouponid: userScid });
                                    })
                                    : [] });
                        }
                        return res;
                    },
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
